import React from 'react';

import { Greet } from '~/types/models';
import Header from '~/App/Modules/TodoList/Components/Record/Header';
import DownloadAppBanner from '../Components/DownloadAppBanner';
import useUserStats from '~/react-hooks/use-user-stats';
import GreetRecordContainer from './GreetRecordContainer';
import ProTipRollup from '~/App/Components/Navigation/ProTipRollup';
import CustomerContext from '~/App/Components/RecorderDrawer/Components/CustomerContext';

export type GreetBodyContainer = {
  greet: Greet;
};

export default function GreetBodyContainer({ greet }: GreetBodyContainer) {
  const { hasInstalledApp, hasSentRollUp } = useUserStats();

  return (
    <div className='flex flex-col h-full'>
      <div className='mb-5'>
        <Header greet={greet} />
      </div>
      <div className='flex flex-col md:flex-row gap-x-7 h-full grow overflow-auto'>
        <div className='flex flex-col justify-between w-full md:w-auto md:min-w-[327px] md:max-w-[440px] md:overflow-auto'>
          <div>
            <GreetRecordContainer greet={greet} />
            {!hasSentRollUp && <ProTipRollup className='mt-5' />}
          </div>
          {!hasInstalledApp && <DownloadAppBanner className='max-w-3xl mt-4' />}
        </div>
        <div className='flex grow mt-4 md:mt-0'>
          <CustomerContext greet={greet} />
        </div>
      </div>
    </div>
  );
}
